import React,{
    useState, 
    useRef, 
    useEffect,
    useImperativeHandle,
    forwardRef
} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";

// --------- component import ---------- //
import { specialCharacterValidate } from '../../../../../../../../../component/common/Helper';
import ValidationMessage from '../../../../../../../../../component/common/ValidationMessage';
import AlertMessage from '../../../../../../../../../component/common/AlertMessage';
import ButtonLoader from '../../../../../../../../../component/common/ButtonLoader';

const FeatureForm = forwardRef((props, ref) => {
    const {
        featureSave , 
        updateFeatureList, 
        formValidateError,
        formActionType,
        isButtonLoader
    } = props;

    const featureAddFormRef = useRef();
    // ----- tagify set ------- //
    const featureSynonymsRef = useRef(null);
    const tagifyRef = useRef(null);
    useEffect(() => {
        if (featureSynonymsRef.current) {
            tagifyRef.current = new Tagify(featureSynonymsRef.current, {
                duplicates: true,
                enforceWhitelist: false,
                callbacks: {
                    add: (e) => {
                        const newTag = e.detail.data.value;
                        const occurrences = tagifyRef.current.value.filter(
                            tag => tag.value === newTag
                        ).length;
                        if (occurrences > 1) {
                            tagifyRef.current.removeTag(e.detail.tag);
                        }
                    }
                }
            });
        }
        return () => {
            if (tagifyRef.current) {
                tagifyRef.current.destroy();
            }
        };
    },[]);

    // -------------- feature input data manage ----------- //
    const [featureErrors, setFeatureErrors] = useState({});
    const [featureFormData, setFeatureFormData] = useState({ 
        feature_name: "",
        feature_synonyms: "",
    });

    const validateField = (name, value) => {
        let error = "";
        if (name === "feature_name") {
            if (!value) {
                error = "Feature name is required.";
            } 
        }
        return error;
    };

    const featureOnInputChange = (e) => {
        const { name, value } = e.target;

        let newVal = value
        if(name === 'feature_name'){
            newVal = specialCharacterValidate(value)
        }
        const fieldError = validateField(name, value);
        setFeatureErrors((prevErrors) => ({ ...prevErrors, [name]: fieldError }));
        setFeatureFormData({ ...featureFormData, [name]: newVal });
    };


    const featureSaveHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in featureFormData) {
            newErrors[key] = validateField(key, featureFormData[key]);
        }
        setFeatureErrors(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            let dataObject = {
                feature_name: featureFormData.feature_name,
                feature_synonyms: featureFormData.feature_synonyms,
            };
            featureSave(dataObject)
            
        }
    }
    useImperativeHandle(ref, () => ({
        resetForm: () => {
            setFeatureFormData((prevState) => ({
                ...prevState,
                feature_name: "",
                feature_synonyms: ""
            }));
        }
    }));
    
    useEffect(() => {
        if( updateFeatureList.length > 0){
            if(formActionType === 'update'){
                let featureUpdateData = updateFeatureList[0];
                setFeatureFormData((prevState) => ({
                    ...prevState,
                    feature_name: featureUpdateData.feature_name,
                }));
                setTimeout(() => {
                    if (featureSynonymsRef.current) {
                        tagifyRef.current.removeAllTags();
                        tagifyRef.current.addTags(featureUpdateData.feature_synonyms);
                    }
                }, 100);
            }
            else{
                setFeatureFormData((prevState) => ({
                    ...prevState,
                    feature_name: "",
                    feature_synonyms: ""
                }));
            }
        }
    },[updateFeatureList])

    const infoPopupData = {
        'feature_name' : {
            'title' : 'Feature name',
            'info' : 'Each Product or Service will have describing features. It can be Price, Model, Warranty, Specifications, and so on. Note that you can create a comprehensive set of Feature here, irrespective of the Products or Service names. You can associate them to relevant Products/Services in the next step.',
        },
        'feature_synonyms': {
            'title' : 'Synonyms',
            'info': 'Enlist all synonyms that go with Features. For example, Rate, Amount, Cost can be the synonyms of Price.'
        }
    }
    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <form ref={featureAddFormRef} className='mb-5' >
                        <div className='row'>
                            <div className='col-md-12 mb-5'>
                                <label className="form-label required">
                                    Feature Name
                                </label>
                                <span 
                                    className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                    onClick={(e) => infoOpenOnCLick('feature_name')}
                                >
                                    <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                </span>
                               
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="Enter feature name"
                                    name='feature_name'
                                    onChange={featureOnInputChange}
                                    value={featureFormData.feature_name}
                                />
                                {featureErrors.feature_name && (
                                    <ValidationMessage className='text-danger' message ={featureErrors.feature_name}/>
                                )}
                            </div>
                            <div className='col-md-12'>
                                <label className="form-label">
                                    Synonyms
                                </label>
                                <span 
                                    className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                                    onClick={(e) => infoOpenOnCLick('feature_synonyms')}
                                >
                                    <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                </span>
                                <span 
                                    className="fs-6 fw-semibold text-primary ms-2 float-end">
                                    (Press Enter to add each synonym.)
                                </span>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="Enter feature synonyms"
                                    name='feature_synonyms'
                                    onChange={featureOnInputChange}
                                    ref={featureSynonymsRef}
                                    value={featureFormData.feature_synonyms}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div className='col-md-12 m-auto text-end'>
                    {
                        formActionType === 'insert' &&
                        <div 
                            className={`btn btn-dark btn-icon btn-sm me-2 ${isButtonLoader ? 'disabled' : ''}`} 
                            onClick={featureSaveHandler}
                        >
                            {
                                isButtonLoader?
                                <ButtonLoader/>
                                :
                                <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                            }
                        </div>
                    }
                    {
                        formActionType === 'update' &&
                        <div 
                            className={`btn btn-primary btn-sm me-2 ${isButtonLoader ? 'disabled' : ''}`}
                            onClick={featureSaveHandler}
                        >
                            Update
                        </div>
                    }
                </div>
                <div className='col-md-12 mt-5'>
                    {
                        formValidateError?.features_setup &&
                        <AlertMessage
                            sub_title = {formValidateError?.features_setup}
                            type = 'danger'
                        />
                    }
                </div>
            </div>
        </>
    )
})

export default FeatureForm